const ssoUrl = process.env.REACT_APP_SSO_URL || 'http://localhost:9000';
const baseUrl = `${ssoUrl}/api/account-deletion-requests`;

export interface AccountDeletionRequestItem {
    id: number;
    userId: number;
    firstName: string;
    lastName: string;
    email: string;
    companyId: number;
    companyName: string;
    requestedAt: string;
    dueAt: string;
}

export class AccountDeletionRequestError extends Error {
    readonly status: number;

    constructor(message: string, status: number) {
        super(message);
        this.name = 'AccountDeletionRequestError';
        this.status = status;
    }
}

function authHeaders() {
    return {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
    };
}

async function request(url: string, init: RequestInit): Promise<any> {
    const res = await fetch(url, { ...init, headers: authHeaders() });
    const body = await res.json().catch(() => ({}));
    if (!res.ok) {
        throw new AccountDeletionRequestError(body.error || `Anfrage fehlgeschlagen (HTTP ${res.status})`, res.status);
    }
    return body;
}

export async function listAccountDeletionRequests(): Promise<AccountDeletionRequestItem[]> {
    const body = await request(baseUrl, { method: 'GET' });
    return body.items || [];
}

export async function approveAccountDeletionRequest(id: number): Promise<void> {
    await request(`${baseUrl}/${id}/approve`, { method: 'POST' });
}

export async function rejectAccountDeletionRequest(id: number, reason: string): Promise<void> {
    await request(`${baseUrl}/${id}/reject`, { method: 'POST', body: JSON.stringify({ reason }) });
}
